import {
  Component,
  OnInit,
  OnDestroy,
  NgModule,
  TemplateRef,
  AfterContentInit,
  ContentChild,
  EmbeddedViewRef,
  OnChanges,
  ViewContainerRef,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  AfterViewInit,
  Pipe,
  PipeTransform,
  Directive
} from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ngn-c-item',
  template: ``
})

export class ItemComponent {

  @ContentChild(TemplateRef, { static : true } ) template: TemplateRef<any>;
  constructor() {
  }

}

@Component({
  selector: 'ngn-c-badge',
  template: ``
})

export class BadgeComponent {

  @ContentChild(TemplateRef, { static : true }) template: TemplateRef<any>;
  constructor() {
  }

}

@Component({
  selector: 'ngn-c-search',
  template: ``
})

export class SearchComponent {

  @ContentChild(TemplateRef, { static : true }) template: TemplateRef<any>;
  constructor() {
  }

}

@Component({
  selector: 'ngn-c-icon',
  template: ``
})

export class IconComponent {

  @ContentChild(TemplateRef, { static : true }) template: TemplateRef<any>;
  constructor() {
  }

}

@Component({
  selector: 'ngn-c-template-renderer',
  template: ``
})

export class TemplateRendererComponent implements OnInit, OnDestroy {

  @Input() data: any;
  @Input() item: any;
  view: EmbeddedViewRef<any>;

  constructor(public viewContainer: ViewContainerRef) {
  }
  ngOnInit() {
    this.view = this.viewContainer.createEmbeddedView(this.data.template, {
      '\$implicit': this.data,
      'item': this.item
    });
  }

  ngOnDestroy() {
    this.view.destroy();
  }

}
